// extracted by mini-css-extract-plugin
module.exports = {"pieChartComponent":"-pie-chart-component-pieChartComponent-CulUoO-"};